import React from "react";
import { useParams } from "react-router-dom";
import { GET_ONE } from "providers/dataProvider";
import MainHeader from "components/templateParts/MainHeader";
import SingleViewHeader from "components/templateParts/SingleViewHeader/SingleViewHeader";
import withModal from "withModal";
import { compose } from "redux";
import { withNotificationCenter } from "NotificationCenter";
import { withAuthCenter } from "AuthCenter";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import useTabs from "hooks/useTabs";
import Box from "@mui/material/Box";
import {
  widgetsConfigById,
  widgetsConfigGroups,
  getWidgetsConfigByHash,
} from "config/resources/clientsResource/show/widgetConfig.js";
import useLoadData from "hooks/useLoadData.js";
import {
  ClientHistoryTab,
  EventsTab,
  PhysicianTab,
  ClientNotesTab,
  LabsTab,
  SalesRepsTab,
  AuthorizedUserTab,
} from "components/pages/clients/ClientsShow/Tabs";
import ClientDocuments from "components/pages/clients/ClientsShow/ClientDocuments.js";
import ClientTestPrices from "components/pages/clients/ClientsShow/ClientTestPrices/ClientTestPrices.js";
import { userRoles } from "config/userRoles";
import { canNotByRoles } from "utils/permissions";

const useStyles = makeStyles((theme) => ({
  appBar: {
    margin: "20px 0 0",
    backgroundColor: "#004C6A !important",
    letterSpacing: "0 !important",
    boxShadow: "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",

  },

  tab: {
    textTransform: "none !important",
    fontWeight: "700 !important",
    letterSpacing: "0 !important",
    cursor: "pointer !important",
    transition: ".5s !important",
    opacity: "0.5 !important",
    fontSize: "14px !important",
    padding: "25px 14.3px 20px !important",
    minWidth: "auto !important",
    lineHeight: "1.75 !important",
    color: "#ffffff !important",
    "&.Mui-selected": {
      opacity: "1 !important",
      color: "#ffffff !important",
    },
  },
  box: {
    padding: "20px 30px 0",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={classes.box}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

const ClientsShowContainer = ({ modalOpen, handleCloseModal, ...props }) => {
  const [tabIndex, handleChangeTab] = useTabs();
  const { id: clientId } = useParams();
  const classes = useStyles();
  const isEditAvailable = canNotByRoles([userRoles.sales]);

  const { data, dataLoaded } = useLoadData(GET_ONE, props.resource, {
    id: clientId,
  });

  return (
    <div>
      <MainHeader title="View Client" />

      <SingleViewHeader
        editLink={isEditAvailable ? "/clients/" + clientId : false}
        title={dataLoaded && data ? `${data.legacyClientId} - ${data.clientName}` : ""}
        subtitle={data?.clientId}
        widgetsConfigByHash={data ? getWidgetsConfigByHash(data) : null}
        widgetsConfigById={widgetsConfigById}
        widgetsConfigGroups={widgetsConfigGroups}
      />

      <AppBar position="static" className={classes.appBar}>
        <Tabs
          value={tabIndex}
          onChange={handleChangeTab}
          indicatorColor="secondary"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#53C4CC",
            },
          }}
        >
          <Tab label="Physicians" className={classes.tab} />
          <Tab label="Labs" className={classes.tab} />
          <Tab label="Events" className={classes.tab} />
          <Tab label="Documents" className={classes.tab} />
          <Tab label="Test Prices" className={classes.tab} />
          <Tab label="Client Notes" className={classes.tab} />
          <Tab label="Activity" className={classes.tab} />
          <Tab label="Sales Rep." className={classes.tab} />
          <Tab label="Authorized User" className={classes.tab} />
        </Tabs>
      </AppBar>
      <TabPanel value={tabIndex} index={0} className={classes.tabPanel}>
        <PhysicianTab clientData={data} clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={1} className={classes.tabPanel}>
        <LabsTab clientData={data} clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={2} className={classes.tabPanel}>
        <EventsTab clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={3} className={classes.tabPanel}>
        <ClientDocuments clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={4} className={classes.tabPanel}>
        <ClientTestPrices clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={5} className={classes.tabPanel}>
        <ClientNotesTab clientData={data}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={6} className={classes.tabPanel}>
        <ClientHistoryTab clientId={clientId} />
      </TabPanel>
      <TabPanel value={tabIndex} index={7} className={classes.tabPanel}>
        <SalesRepsTab clientId={clientId} isEditAvailable={isEditAvailable}/>
      </TabPanel>
      <TabPanel value={tabIndex} index={8} className={classes.tabPanel}>
        <AuthorizedUserTab clientId={clientId}/>
      </TabPanel>
    </div>
  );
};

export default compose(
  withModal,
  withNotificationCenter(),
  withAuthCenter()
)(ClientsShowContainer);
